import React from 'react';
import dynamic from 'next/dynamic';
import { ArticleConstants } from '../../adapters/helpers/Constants';

const ProductsOverview = dynamic(() => import('../ProductsOverview/ProductsOverview'));

interface RelatedProductsProps {
    products: object[];
    isMobile: boolean;
    isArticle: boolean;
    rightArrowIconArticle: object;
    leftArrowIconArticle: object;
    onClickCallback: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const RelatedProducts: React.FC<RelatedProductsProps> = ({ products, isMobile, isArticle, onClickCallback, rightArrowIconArticle, leftArrowIconArticle }) => {
    return (
        <div className={`article-related-products ${isMobile ? 'mobile w-full pb-4 md:pb-1 text-left' : 'desktop pb-1h md:mt-7less lg:mt-6less'}`}>
            <h2
                className={
                    isMobile
                        ? 'text-2xl leading-34 font-semi-bold text-revamp_blueText pb-1 border-b border-solid border-black mb-8 mx-2h md:mx-0'
                        : 'article-related-products-heading font-semi-bold text-26 leading-30 text-revamp_grey_text md:text-revamp_blueText pb-2'
                }
            >{ArticleConstants.RelatedProducts}</h2>
            {isMobile ? (
                <ProductsOverview
                    products={products}
                    isCarrousel={true}
                    onClickCallback={onClickCallback}
                    itemsPerLine={1}
                    isArticle={isArticle}
                    rightArrowIconArticle={rightArrowIconArticle}
                    leftArrowIconArticle={leftArrowIconArticle}
                />
            ) : (
                <div className="desktop-products">
                    {products.map((product, index) => (
                        <div key={index} className="product-item border border-revamp_product_brdr rounded-xl mb-0 md:mb-9">
                            <ProductsOverview
                                products={[product]}
                                isCarrousel={false}
                                onClickCallback={onClickCallback}
                                itemsPerLine={1}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RelatedProducts;